'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _cloneDeep2 = require('lodash/cloneDeep');

var _cloneDeep3 = _interopRequireDefault(_cloneDeep2);

exports.default = rotate;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function rotate(props) {
    var series = props.series,
        seriesNormalized = props.seriesNormalized,
        minX = props.minX,
        maxX = props.maxX,
        maxY = props.maxY,
        minY = props.minY;
    var scaleX = props.scaleX,
        scaleY = props.scaleY;
    var _scaleX = scaleX,
        paddingLeft = _scaleX.paddingLeft,
        paddingRight = _scaleX.paddingRight;
    var _scaleY = scaleY,
        paddingTop = _scaleY.paddingTop,
        paddingBottom = _scaleY.paddingBottom;

    scaleX = (0, _cloneDeep3.default)(scaleX);
    scaleY = (0, _cloneDeep3.default)(scaleY);
    scaleX.paddingLeft = paddingTop;
    scaleX.paddingRight = paddingBottom;
    scaleX.swap = !scaleX.swap;
    scaleY.paddingTop = paddingLeft;
    scaleY.paddingBottom = paddingRight;
    scaleY.swap = !scaleY.swap;
    scaleY.direction = -1;

    return {
        series: series,
        seriesNormalized: seriesNormalized,
        maxX: maxX,
        maxY: maxY,
        minX: minX,
        minY: minY,
        scaleX: scaleX,
        scaleY: scaleY
    };
}


/*****************
 ** WEBPACK FOOTER
 ** ../~/rumble-charts/lib/helpers/transforms/rotate.js
 ** module id = 1561
 ** module chunks = 3
 **/